import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Editor } from "primereact/editor";
import { DialogActions } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import QuotationBasicInfo from "../../sales/quotation/quotationDetail/quotationBasicInfo";
import { saveApprovalProcessAction } from "../../../../services/usersService";
import SoBasicInfo from "../../sales/salesOrder/salesOrderDetail/soBasicInfo";
import PoBasicInfo from "../../inventory/procurement/purchase-order/purchaseOrderDetail/poBasicInfo";
import PrBasicInfo from "../../inventory/procurement/purchase-request/PrBasicInfo";
import InvoiceBasicInfo from "../../finance/invoice/invoiceDetail/invoiceBasicInfo";
import IncomingInvoiceBasicInfo from "../../finance/incomingInvoice/incomingInvoiceDetail/incomingInvoiceBasicInfo";
import RfqBasicInfo from "../../inventory/procurement/rfq/rfq-detail/RfqBasicInfo";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import { sendApprovalRequests, setObject } from "../../../../utils/utils";
import ContractBasicInfo from "../../inventory/procurement/contract/contract-detail/ContractBasicInfo";
function ApprovalAction({
  approvalProcess = { ID: 0, docID: 0, appCode: "" },
  onConfirmSave,
  onCloseDialog,
}) {
  const { reload, setReload, socket } = useGlobalData();
  const { auth } = store.getState();
  const { fullName } = auth.user;
  const [note, setNote] = useState("");
  const [openApprovalNote, setOpenApprovalNote] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");

  useEffect(() => {
    const { auth } = store.getState();

    if (approvalProcess.ID > 0) {
      setObject(socket, "lock", approvalProcess.ID, "APVL", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (approvalProcess.ID > 0) {
        setObject(socket, "release", approvalProcess.ID, "APVL", auth.user);
      }
    };
  }, [reload]);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          {approvalProcess.appCode === "QUOT" ? (
            <QuotationBasicInfo quotationID={approvalProcess.docID} />
          ) : approvalProcess.appCode === "SORD" ? (
            <SoBasicInfo salesOrderID={approvalProcess.docID} />
          ) : approvalProcess.appCode === "PORQ" ? (
            <PrBasicInfo purchaseRequestID={approvalProcess.docID} />
          ) : approvalProcess.appCode === "PRFQ" ? (
            <RfqBasicInfo rfqID={approvalProcess.docID} approvalAction={true} />
          ) : approvalProcess.appCode === "PCOT" ? (
            <ContractBasicInfo contractID={approvalProcess.docID} />
          ) : approvalProcess.appCode === "PORD" ? (
            <PoBasicInfo purchaseOrderID={approvalProcess.docID} />
          ) : approvalProcess.appCode === "INVO" ? (
            <InvoiceBasicInfo invoiceID={approvalProcess.docID} />
          ) : approvalProcess.appCode === "INVR" ? (
            <IncomingInvoiceBasicInfo invoiceID={approvalProcess.docID} />
          ) : null}
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={onCloseDialog}
        >
          <i className="fas fa-window-close"></i>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger btn-md btn-pill btn-bold mr-1"
          onClick={() => {
            setApprovalAction("Rejection");
            setOpenApprovalNote(true);
          }}
        >
          <i className="fas fa-times-circle"></i>
          Reject
        </button>
        <button
          type="button"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={() => {
            setApprovalAction("Approval");
            setOpenApprovalNote(true);
          }}
        >
          <i className="fas fa-check-circle"></i>
          Approve
        </button>
      </DialogActions>
      <DialogLayout
        open={openApprovalNote}
        title={`${approvalAction} Note Form`}
        onCloseDialog={() => {
          setOpenApprovalNote(false);
        }}
        maxWIdth="md"
      >
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Editor
              style={{ height: "200px", width: "100%" }}
              onTextChange={(e) => {
                setNote(e.htmlValue);
              }}
              value={note}
              placeholder="Type your approval or rejection reason here... (optional)"
            />
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setNote("");
              setOpenApprovalNote(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={() => {
              if (approvalAction === "Approval") {
                confirmApprovalAction(2);
              } else if (approvalAction === "Rejection") {
                confirmApprovalAction(3);
              }
            }}
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function confirmApprovalAction(statusID) {
    const approvalProcessSave = {
      ...approvalProcess,
    };
    let actionDesc = "";
    if (statusID === 2) {
      actionDesc = "approve";
    } else if (statusID === 3) {
      actionDesc = "reject";
    }
    approvalProcessSave.note = note;
    approvalProcessSave.statusID = statusID;
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to " + actionDesc + " this Document ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText:
          `<i class="fas fa-check-circle"></i> Yes, ` + actionDesc + ` it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          saveApprovalProcessAction(approvalProcessSave).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: `${
                statusID === 2 ? "Approved" : statusID === 3 ? "Rejected" : null
              }`,
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });

            if (statusID === 2) {
              let toUsers = [];
              const { data } = response.data;

              if (
                data.notificationToUsers &&
                data.notificationToUsers.length > 0
              ) {
                data.notificationToUsers.map((notificationToUser, index) => {
                  toUsers.push({
                    ID: notificationToUser.toUserID,
                  });
                });
              }

              if (toUsers && toUsers.length > 0) {
                sendApprovalRequests(socket, fullName, toUsers);
              }
            }

            setNote("");
            setOpenApprovalNote(false);
            onConfirmSave();
            setReload(reload + 1);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default ApprovalAction;
